// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7, Phase
// C.2): panel = MenuPanel (dialog surface + overlay shadow + radiusCard + Y
// padding), rows = MenuPanelItem (Y/Z1 padding, radiusControl, the `hover`
// wash, @coarse tap height). The legacy ListInDropdown recipe is gone with
// its armor: the `margin: '- -Z2'` pull existed to claw rows back across the
// old hand-rolled `padding: 'Z1 A'` body — MenuPanelItem rows are full-width
// inside MenuPanel's own Y padding, so nothing needs pulling out — and the
// per-row `':hover': { '& svg': ... }` opacity block only fought the old
// KeyValueColumnFields/DropdownItem svg-opacity games, which MenuPanelItem
// does not have.
const Dropdownassistantmenu = {
  extends: 'MenuPanel',
  gap: 'A',
  CaptionTitle: {
    // Align the caption with MenuPanelItem's Z1 label inset (same idiom as
    // MarketplaceFilters' MenuLabel).
    padding: '- Z1',
    Text: {
      text: '{{ ai.menu.title | polyglot }}'
    }
  },
  Items: {
    flow: 'y',
    gap: '0',
    childExtends: 'MenuPanelItem',
    childProps: {
      // Flat `text` renders before child elements — flex order puts the icon
      // back in front (same recipe as EditInNavbarMenu).
      Icon: {
        order: '-1',
        margin: '- Y1 - -'
      }
    },
    childrenAs: 'props',
    children: (el) => [
      {
        text: '{{ ai.menu.playground | polyglot }}',
        Icon: {
          name: 'wave'
        },
        onClick: (ev, el) => {
          el.call('openRouterModal', '/ai-playground')
        }
      }
    ]
  }
}

export { Dropdownassistantmenu as 'Dropdown.AssistantMenu' }
